/* Daellia V2 — small, dependency-free helpers. */
(function () {
  'use strict';

  var doc = document.documentElement;
  var body = document.body;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal on scroll ---------- */
  function initReveal(root) {
    var items = (root || document).querySelectorAll('.dl-reveal:not(.is-in)');
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window) || doc.classList.contains('shopify-design-mode')) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });

    /* Safety net: never leave content hidden. */
    window.setTimeout(function () {
      document.querySelectorAll('.dl-reveal:not(.is-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add('is-in');
      });
    }, 2500);
  }

  /* ---------- Scrolled state (header border) ---------- */
  function initScrollState() {
    var wrapper = document.querySelector('.page-wrapper');
    var ticking = false;
    function read() {
      ticking = false;
      var y = Math.max(window.scrollY || 0, wrapper ? wrapper.scrollTop : 0);
      body.classList.toggle('dl-scrolled', y > 8);
    }
    function onScroll() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(read); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    if (wrapper) wrapper.addEventListener('scroll', onScroll, { passive: true });
    read();
  }

  /* ---------- Footer visibility (hides the mobile sticky add to cart) ---------- */
  function initFooterWatch() {
    var footer = document.querySelector('footer');
    if (!footer || !('IntersectionObserver' in window)) return;
    if (!document.querySelector('sticky-add-to-cart')) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        body.classList.toggle('dl-footer-in-view', entry.isIntersecting);
      });
    }, { threshold: 0 });
    io.observe(footer);
  }

  /* ---------- Sticky add to cart: unavailable variant -> scroll to picker ---------- */
  function initStickyFallback() {
    var sticky = document.querySelector('sticky-add-to-cart');
    if (!sticky) return;
    sticky.addEventListener('click', function (event) {
      var btn = event.target.closest('.sticky-add-to-cart__button');
      if (!btn || !btn.disabled) return;
      var picker = document.querySelector('.product-details variant-picker, .product-details .variant-picker');
      if (picker) {
        picker.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        var input = picker.querySelector('input:checked, input, select');
        if (input) window.setTimeout(function () { input.focus({ preventScroll: true }); }, 400);
      }
    }, true);
  }

  function init() {
    initReveal();
    initScrollState();
    initFooterWatch();
    initStickyFallback();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: re-run when sections are re-rendered. */
  document.addEventListener('shopify:section:load', function (event) { initReveal(event.target); });
})();